import {
  CONTRACT_AUTHENTICATION_INITIALIZE,
  PARTICIPANT_STATUS_SUCCESS,
} from '@app/store/actionTypes';
import { ContractAuthenticationAction } from '@app/store/contract-authentication/actions';

import { ParticipantAction } from '../actions';

interface Requester {
  email: string;
  name: string;
}

const initialState: Requester = {
  email: '',
  name: '',
};

export default function reducer(
  state: Requester = initialState,
  action: ParticipantAction | ContractAuthenticationAction
) {
  switch (action.type) {
    case CONTRACT_AUTHENTICATION_INITIALIZE:
      return initialState;
    case PARTICIPANT_STATUS_SUCCESS:
      return action.payload.requester;
    default:
      return state;
  }
}
